import { Menu } from 'antd';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuInfo } from 'types';

import FieldResourcesIcon from '../../icons/FieldResourcesIcon';
import MapFieldsIcon from '../../icons/MapFieldsIcon';
import { detailsViewTypeEnum, ITabMenuItem } from '../../slice/types';

interface IProps {
  selectedKey: detailsViewTypeEnum;
  onClickMenu: (clickedItem: MenuInfo) => void;
  isResourcesTabHidden?: boolean;
  isRoutes?: boolean;
}

const TaskTabs = ({
  selectedKey,
  onClickMenu,
  isResourcesTabHidden,
  isRoutes,
}: IProps) => {
  const { t } = useTranslation();

  const menuItems: ITabMenuItem<detailsViewTypeEnum>[] = useMemo(() => {
    let items = [
      {
        title: t('Task.Create.TaskFields', 'Task fields'),
        icon: <MapFieldsIcon />,
        key: detailsViewTypeEnum.map,
      },
      {
        title: t('Task.Create.TaskResources', 'Task resources'),
        icon: <FieldResourcesIcon />,
        key: detailsViewTypeEnum.resources,
        id: 'resource',
      },
    ];

    if (isResourcesTabHidden) {
      return items.filter(item => item.id !== 'resource');
    }

    if (isRoutes) {
      items.push({
        title: t('Task.FieldsComplettionRoutes', 'Fields completion / routes'),
        icon: <FieldResourcesIcon />,
        key: detailsViewTypeEnum.routes,
        id: 'routes',
      });
    }

    return items;
  }, [t, isResourcesTabHidden, isRoutes]);

  return (
    <Menu mode="inline" selectedKeys={[selectedKey]} onClick={onClickMenu}>
      {menuItems.map(item => (
        <Menu.Item icon={item.icon} key={item.key} id={item.id}>
          {item.title}
        </Menu.Item>
      ))}
    </Menu>
  );
};

export default TaskTabs;
